<template>
  <g
    :transform="transform"
    class="icon"
    @click.stop="showList"
  >
    <use
      x="0"
      y="0"
      :width="visualizationPinSize.width"
      :height="visualizationPinSize.height"
      :fill="visualizationPinColor"
      :transform="visualizationPinTransform"
      xlink:href="#pin-person"
    />
    <g
      :transform="numberPosition"
      class="number"
    >
      <circle
        cx="0"
        cy="0"
        :r="numberRadius"
        :stroke-width="numberRadius / 32"
        fill="#fff"
        stroke="#6c6c6c"
      />
      <text
        x="0"
        y="0"
        :dy="textSize * 35 / 100"
        :font-size="textSize"
        font-weight="bold"
        fill="#6c6c6c"
        text-anchor="middle"
      >{{ persons.length }}{{ persons.length > 9 ? '+' : '' }}</text>
    </g>
  </g>
</template>

<script>
import map from '@/mixins/map.js';
import mixinsPin from '@/mixins/map_pin.js';

export default {
  mixins: [map, mixinsPin],
  props: {
    persons: {
      type: Array,
      default() {
        return [];
      },
    },
    visualizationPinSize: {
      type: Object,
      default() {
        return {
          width: 0,
          height: 0,
        };
      },
    },
  },
  computed: {
    // TODO: 位置情報があやしいので複数人のリスト表示をするときに確認する
    visualizationPinX: ({ persons }) => persons[0].thingPositions[0].positionX,
    visualizationPinY: ({ persons }) => persons[0].thingPositions[0].positionY,
    destinationList: ({ $store }) => $store.state.searchResult.destinations,
    scale: ({ $store }) => 1 / $store.state.map.scale,
    selectedPin: ({ $store }) => $store.state.current.spotId,
    isVisualizationPinSelected() {
      if (!this.$store.state.current.isGroupSelected) return false;

      return this.persons.every((person) => this.destinationList.some((destination) => destination.id === person.id));
    },
    // NOTE: 座標の調整
    transform() {
      return `translate(${this.visualizationPinX}, -${this.visualizationPinY}) scale(${1 / this.$store.state.map.scale})`;
    },
    // NOTE: 選択中のスポットはサイズを大きくする
    visualizationPinScale: ({ isVisualizationPinSelected }) => ((isVisualizationPinSelected) ? 2.5 : 1),
    visualizationPinTransform() {
      // NOTE: ピンの先端を座標に合わせる
      const width = -this.visualizationPinSize.width / 2;
      const height = -this.visualizationPinSize.height;
      return `scale(${this.visualizationPinScale}) translate(${width}, ${height})`;
    },
    numberRadius: ({ visualizationPinSize }) => visualizationPinSize.width / 3,
    textSize: ({ numberRadius }) => ((numberRadius * 2) / 3) * 2,
    numberPosition() {
      return `translate(${this.numberRadius * this.visualizationPinScale} -${this.visualizationPinSize.height * this.visualizationPinScale}) scale(1.25)`;
    },
  },
  methods: {
    showList() {
      // NOTE: 仲居さんとの共通メソッド
      this.$store.commit('current/switchGroupSelected', true);
      this.$store.commit('searchResult/setDestinations', this.persons);
      this.$store.dispatch('destinationList/show');

      // NOTE: 女将さん固有メソッド
      this.$store.dispatch('map/switchShiftMap', this.visualizationPinX);
      this.$store.dispatch('appNavigator/updateNoOperationTimer', this.$store.state.appNavigator.noOperationTimer);
    },
  },
};
</script>

<style scoped lang="scss">
.number {
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// multiple.vue?aaa2e9cc